"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var react_intl_1 = require("react-intl");
var CustomerValidationErrorText = function (_a) {
    var style = _a.style;
    var intl = react_intl_1.useIntl();
    return (<>
      <core_1.Typography component="div" variant="body1" data-test="text:customerValidationError.description" className={style.paragraph}>
        <react_intl_1.FormattedMessage id="payment.customerValidationError.description" values={{
        phoneNumber: (<a href={"tel:" + intl.formatMessage({ id: 'payment.phoneNumber' })}>
                <react_intl_1.FormattedMessage id="payment.phoneNumber" defaultMessage=" "/>
              </a>),
        email: (<a href={"mailto:" + intl.formatMessage({ id: 'payment.email' })}>
                <react_intl_1.FormattedMessage id="payment.email" defaultMessage=" "/>
              </a>),
    }}/>
      </core_1.Typography>
    </>);
};
exports.default = CustomerValidationErrorText;
